import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';


export function isNepEnrollment() {

	return !useSelector<TcsmStates, number>(state => state?.newHireEnrollmentState?.memberCurrentEmploymentId);

}